import { IOktaMFAFactorProfile } from "./IOktaMFAFactorProfile";
import { IOktaMFAFactorLinks } from "./IOktaMFAFactorLinks";

export interface IOktaMFAFactor {
  id: string;
  factorType: string;
  provider: string;
  vendorName: string;
  status: string;
  created: Date;
  lastUpdated: Date;
  profile: IOktaMFAFactorProfile;
  _links: IOktaMFAFactorLinks;
}
